import React, { useState } from "react";
import useFlotteExport from "../../hooks/useFlotteExport";

const ExportButtons = ({ flotteList, flotteMeta }) => {
  const {
    isExporting,
    exportProgress,
    exportFlotteToExcel,
    exportCurrentPageToExcel,
    cancelExport,
  } = useFlotteExport();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleExportAll = () => {
    exportFlotteToExcel("export-flotte-complet");
    setIsDropdownOpen(false);
  };

  const handleExportCurrentPage = () => {
    exportCurrentPageToExcel(flotteList, "export-flotte-page-courante");
    setIsDropdownOpen(false);
  };

  const getTotalCount = () => {
    return flotteMeta?.total || 0;
  };

  const getCurrentCount = () => {
    return flotteList.length || 0;
  };

  return (
    <>
      {isExporting && (
        <button
          className="btn btn-danger btn-xs ml-2"
          onClick={(e) => {
            e.stopPropagation();
            cancelExport();
          }}
          title="Annuler l'export"
          style={{ padding: "2px 6px", fontSize: "10px" }}
        >
          <i className="fas fa-times mr-1"></i>
          Annuler
        </button>
      )}
      <div className="dropdown">
        <button
          className={`btn btn-default btn-sm d-flex align-items-center ${
            isExporting ? "disabled" : ""
          }`}
          type="button"
          // onClick={toggleDropdown}
          disabled={isExporting}
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded={isDropdownOpen}
        >
          {isExporting ? (
            <>
              <i className="fas fa-spinner fa-spin mr-2"></i>
              {exportProgress.total !== "?" ? (
                <span>
                  Page {exportProgress.current}/{exportProgress.total}
                </span>
              ) : (
                <span>Page {exportProgress.current}</span>
              )}
            </>
          ) : (
            <>
              <i className="fas fa-file-excel mr-2"></i>
              Export Excel
            </>
          )}
        </button>

        <div className={`dropdown-menu ${isDropdownOpen ? "show" : "hide"}`}>
          <button
            className={`dropdown-item ${
              isExporting || getTotalCount() === 0 ? "disabled" : ""
            }`}
            onClick={handleExportAll}
            disabled={isExporting || getTotalCount() === 0}
          >
            <i className="fas fa-download mr-2"></i>
            <div>
              <strong>Export complet</strong>
              <br />
              <small className="text-muted">
                {getTotalCount().toLocaleString()} véhicule
                {getTotalCount() > 1 ? "s" : ""}
                {getTotalCount() > 0 ? " (toutes les pages)" : ""}
              </small>
            </div>
          </button>

          <div className="dropdown-divider"></div>

          <button
            className={`dropdown-item ${
              isExporting || getCurrentCount() === 0 ? "disabled" : ""
            }`}
            onClick={handleExportCurrentPage}
            disabled={isExporting || getCurrentCount() === 0}
          >
            <i className="fas fa-file-export mr-2"></i>
            <div>
              <strong>Export page courante</strong>
              <br />
              <small className="text-muted">
                {getCurrentCount().toLocaleString()} véhicule
                {getCurrentCount() > 1 ? "s" : ""}
                {getCurrentCount() > 0 ? " (affichés)" : ""}
              </small>
            </div>
          </button>
        </div>
      </div>
    </>
  );
};

export default ExportButtons;
